import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function EnterpriseAnalyticsCase() {
  return <CaseStudyPage slug="enterprise-analytics-dashboard" />;
}